import { render } from "./Nearby.vue?vue&type=template&id=3d5c8740"
import script from "./Nearby.vue?vue&type=script&lang=js"
export * from "./Nearby.vue?vue&type=script&lang=js"

import "./Nearby.vue?vue&type=style&index=0&id=3d5c8740&lang=css"

import exportComponent from "C:\\Entwicklung\\werbeo-app-private\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__